import { useFetcher } from '@f-technology-srl/client-authorization';
import { useHandleRespError } from '@f-technology-srl/react-hook-utils';

export function useDeleteAgency() {
  const fetcher = useFetcher();
  const { error, handle } = useHandleRespError(false);

  return {
    error,
    async deleteAgency(agency_id: string) {
      const result = await fetcher(`/api/agency/delete/${agency_id}`, {
        method: 'DELETE',
        body: {},
      });

      return handle<boolean>(result);
    },
  };
}
